export default {
  root: {
    backgroundColor: '#494949',
    opacity: 0.2
  }
};
